import React, { useContext, useState, useEffect, useRef } from "react";
import {
  StyleSheet,
  View,
  ScrollView,
  useWindowDimensions,
} from "react-native";
import { Context as PlanContext } from "@context/PlanContext";
import { useMediaQuery } from "react-responsive";
import { Text } from "@geist-ui/react";
import { Cpu } from "@geist-ui/icons";
import colors from "@res/colors";
import fonts from "@res/fonts";

const OverviewContent = ({ navigation, route }) => {
  const {
    state: { plan, tabs },
  } = useContext(PlanContext);
  const window = useWindowDimensions();
  const isTabletOrMobile = useMediaQuery({ maxWidth: 1024 });
  const isMobile = useMediaQuery({ maxWidth: 600 });

  const goalComp = (text, color) => (
    <View
      key={text.substring(0, 25)}
      style={[styles.goalContainer, { marginBottom: -10 }]}
    >
      <Cpu color={color} />
      <Text style={{ color: "black", marginLeft: 10 }} p>
        {text}
      </Text>
    </View>
  );

  const stepComp = (text, color) => (
    <View
      key={text.substring(0, 25)}
      style={[styles.goalContainer, { marginLeft: 30, marginTop: 18 }]}
    >
      <View
        style={{
          height: 8,
          width: 8,
          borderRadius: 20,
          backgroundColor: color,
        }}
      />
      <Text style={{ color: "#303030", marginLeft: 10 }} small>
        {text}
      </Text>
    </View>
  );

  return (
    <View style={styles.overview}>
      {/* <View>
        <Text style={{ color: "white" }} small>
          {plan.prospectCompany}'s unique Sandbox API Key
        </Text>
        <View style={styles.keyField}>
          <Text style={{ color: "black" }} small>
            {plan.apiKey}
          </Text>
        </View>
      </View> */}
      <View
        style={[
          styles.overviewBox,
          {
            background:
              "linear-gradient(" +
              150 +
              "deg, " +
              "white" +
              ", " +
              "rgba(248,248,248,0.9)" +
              ")",
          },
        ]}
      >
        <Text
          style={{
            color: plan.company.darkColor,
            fontFamily:
              plan.company.headingFont != null
                ? plan.company.headingFont
                : null,
          }}
          h5
        >
          {plan.prospectCompany} Integration Overview
        </Text>
        <Text style={{ color: "#303030" }} small>
          {tabs.filter((tab) => tab.type == 1).length} goal,{" "}
          {tabs.filter((tab) => tab.type == 2).length} steps
        </Text>
        <View style={{ marginVertical: 10 }} />
        {tabs.map((tab) => {
          if (tab.type == 1) {
            return goalComp(
              tab.title,
              plan.company.headingColor != null
                ? plan.company.headingColor
                : plan.company.darkColor
            );
          } else if (tab.type == 2) {
            return stepComp(
              tab.title,
              plan.company.headingColor != null
                ? plan.company.headingColor
                : plan.company.darkColor
            );
          }
        })}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  keyField: {
    backgroundColor: "white",
    paddingHorizontal: 20,
    paddingVertical: 12,
    borderRadius: 6,
    marginTop: 10,
    width: "100%",
  },
  overviewBox: {
    //marginTop: 20,
    width: "100%",
    padding: 40,
    borderRadius: 6,
  },
  boxBackground: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1,
    borderRadius: 6,
  },
  goalContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 2,
  },
  goalCircle: {
    height: 18,
    width: 18,
    borderRadius: 100,
    marginRight: 10,
  },
  stepSquare: {
    height: 8,
    width: 8,
    marginRight: 12,
  },
});

export default OverviewContent;
